export default "/34887f8f847f5d202a469a9dd4881160882f8c6b/bce1c79c076cfd26ce49a1f2fa85ca50.svg";